<template minapp="mpx" xlang="wxml">
  <view wx:class="probability {{pageFrom}}">
    <view class="process-container">
      <view wx:if="{{imgUrl}}" wx:style="{{imgUrl}}" class="image"></view>
      <view class="one" wx:style="{{oneStyle}}"></view>
      <view class="bg" wx:style="{{bgStyle}}"></view>
    </view>
    <view class="tips">- {{ tip }} -</view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { parseDate, formatDate } from '@/utils/baseDate'
  import { getPadPrice, getFinalPrice } from '@/utils/money'
  import store from '@/store'
  import { getStorage } from '@/utils/storage'
  import { STORAGE_DETAIL_SEARCH_QUERY } from '@/utils/train-storage'

  createComponent({
    props: {
      probability: {
        type: String,
        value: 'low'
      },
      tip: {
        type: String,
        value: '备选越多 成功率越高'
      },
      pageFrom: {
        type: String,
        value: ''
      }
    },
    computed: {
      imgUrl() {
        const urls = {
          low: [
            'https://dpubstatic.udache.com/static/dpubimg/qBpMALHkNOlnAcbu8-BpE.png',
            'https://ut-static.udache.com/webx/sfc/23bYyGtPK_6Hi2HhuCxH0.png'
          ],
          middle: [
            'https://dpubstatic.udache.com/static/dpubimg/_1UJNX4Hq4Tlvh3IJ6dmm.png',
            'https://ut-static.udache.com/webx/sfc/9pqvlAVEZB8xz-31KSVuT.png'
          ],
          high: [
            'https://dpubstatic.udache.com/static/dpubimg/BurpGHU_FoOQ9KsM5g0sY.png',
            'https://ut-static.udache.com/webx/sfc/ivlCcwKaGppM6GlrmfJ9f.png'
          ]
        }
        let url = urls[this.probability][this.pageFrom === 'detail-page' ? 1 : 0]
        return {
          'background-image': `url("${url}")`,
          'background-size': 'cover',
          'background-repeat': 'no-repeat'
        }
      },
      oneStyle() {
        let angle
        let bgColor
        switch(this.probability) {
          case 'low':
            angle = '-119deg'
            bgColor = '#FF5900'
            break
          case 'middle':
            angle = '-56deg'
            bgColor = '#00BE46'
            break
          case 'high': 
            angle = '0deg'
            bgColor = '#00B39B'
            break
        }
        return {
          transform: `rotate(${angle})`,
          background: bgColor
        }
      },
      bgStyle() {
        let bgColor
        switch(this.probability) {
          case 'low':
            bgColor = '#FFEEE5'
            break
          case 'middle':
            bgColor = '#EBFBF1'
            break
        }
        return {
          background: bgColor
        }
      }
    },
  })
</script>

<style scoped lang="stylus">
  .probability
    position absolute
    // top -2px
    right 12px
    // background url('https://dpubstatic.udache.com/static/dpubimg/HGc2P2TsvCgjqxO_GtpCZ.png')
    // background-repeat no-repeat
    // background-size cover
    // background pink
    z-index 10
    display flex
    flex-direction column
    align-items center
    width 154px
    height 104px
    .process-container
      width 154px
      height 85px
      display flex
      flex-direction column
      align-items center
      justify-content flex-end
      position relative
      background url('https://dpubstatic.udache.com/static/dpubimg/Dntl7EKXkr71fHNZO0S1u.png')
      background-size contain
      background-repeat no-repeat
      overflow hidden
      // border-radius 500px 500px 0 0
      .one
        position absolute
        background #FF5900
        z-index -1
        height 75px
        width 150px
        left 0px
        bottom 0
        transform-origin bottom center
        border-radius 200px 200px 0 0
        transition-duration 0.6s
      .bg
        position absolute
        z-index -2
        width 140px
        height 75px
        border-radius 200px 200px 0 0
      .image
        width 116px
        height 64px
        transition-duration 0.6s
    .tips
      line-height 12px
      font-size 12px
      color #999999
      font-weight 400
      font-family PingFangSC-Regular
      margin-top 7px
  .detail-page
    right 4px
    height 120px
    .process-container
      background-image url('https://ut-static.udache.com/webx/sfc/IqVK3Q9aadu4qqrS8OeIQ.png')
    .tips
      margin-top 10px
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>